var TriggerDataParser = function(component) {
    this.component = component;
}
Object.assign(
    TriggerDataParser.prototype,
    {
        sheets: {
            properties: "Properties",
            dataExtension: "Data Extension Fields"
        },
        cellIdxs: {
            properties: {
                col: "C",
                row: 5
            },
            dataExtension: {
                col: "C",
                row: 4
            }
        },
        booleanFields: ["primary_key", "nullable", "template_field"],
        parse: function(xlsx) {
            var properties, dataExtension;

            //
            // Get properties
            properties = xlsx.parsePropertiesValuesBlock(
                this.sheets.properties,
                this.cellIdxs.properties.col,
                xlsx.nextColLabel(this.cellIdxs.properties.col),
                xlsx.nextColLabel(xlsx.nextColLabel(this.cellIdxs.properties.col)),
                this.cellIdxs.properties.row,
                8
            );
            //console.log(properties);

            //
            // Get data extension
            dataExtension = xlsx.parseTableBlock(
                this.sheets.dataExtension,
                this.cellIdxs.dataExtension.col,
                this.cellIdxs.dataExtension.row
            );
            dataExtension.forEach((field) => {
                var k;
                for (k in field) {
                    if (this.booleanFields.indexOf(k) != -1) {
                        field[k] = (field[k].toLowerCase() == "true") ? true : false;
                    }
                }
            });
            //console.log(dataExtension);

            return {
                properties,
                dataExtension
            };
        }
    }
)
export default function(file, component) {
    return new TriggerDataParser(file, component);
}